import axios from "axios";
import { Config } from "../../data/config";

export const SET_TAXES = "SET_TAXES";
export const setTaxes = payload => {
  return { type: SET_TAXES, payload };
};

export function getTaxes(bid)
{
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/onboarding/taxes/${bid}`)
      .then(response => {
        dispatch(setTaxes(response.data));
      });
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/taxes.js